import React, { useRef, useEffect, useState } from 'react';
import { TToastNotificationProps } from '../components/Toast/ToastNotification';

function useToastNotification<T>() {
  const toastNotification = useRef<((props: TToastNotificationProps) => void) | null>(null);
  const [toast, setToast] = useState<React.FC<T> | null>(null);

  useEffect(() => {
    const loadComponent = async () => {
      try {
        toastNotification.current = (
          await import(/* webpackChunkName: "toastNotification" */ '../components/Toast/ToastNotification')
        ).default;
        setToast(() => toastNotification.current as React.FC<T> | null);
      } catch {}
    };
    if (!toast) {
      void loadComponent();
    }
  }, [toast]);

  return {
    toast,
  } as {
    toast: React.FC<T>;
  };
}

export default useToastNotification;
